module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9Fcwd"))).then(() => module.bundle.root('jnagv'));